import { render } from "./StaticPage.vue?vue&type=template&id=57d009a0&ts=true"
import script from "./StaticPage.vue?vue&type=script&lang=ts"
export * from "./StaticPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__